import React, { useMemo } from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import type { AccommodationCategory } from '@graphql/generated-base';
import { FilterFacet } from '@apps/stays/components/filters/FilterFacet';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';

type PropertyTypeOption = Readonly<{
  label: string;
  value: AccommodationCategory;
}>;

type PropertyTypeFacetProps = Readonly<{
  title: string;
  propertyTypes: ReadonlyArray<PropertyTypeOption>;
  selectedCategories: ReadonlyArray<AccommodationCategory>;
  propertyCategoryCounts: Readonly<Record<AccommodationCategory, number>>;
  onCategoryToggle: (category: AccommodationCategory) => void;
}>;

export const PropertyTypeFacet: React.FC<PropertyTypeFacetProps> = ({ title, propertyTypes, selectedCategories, propertyCategoryCounts, onCategoryToggle }) => {
  const selectedSet = useMemo(() => new Set(selectedCategories), [selectedCategories]);
  return (
    <FilterFacet title={title}>
      <Flex
        flexDirection="column"
        gap={5}
      >
        {propertyTypes.map(propertyType => (
          <StyledCheckboxV2
            key={propertyType.value}
            isChecked={selectedSet.has(propertyType.value)}
            onChange={() => onCategoryToggle(propertyType.value)}
            id={`property-type-${propertyType.value}`}
            isDisabled={!propertyCategoryCounts[propertyType.value]}
          >
            <TextV2
              typographyVariant="body1"
              color="mono14"
            >
              {propertyType.label}
              {'\u00A0'}
              <TextV2
                as="span"
                typographyVariant="body1"
                color="mono10"
              >
                ({propertyCategoryCounts[propertyType.value]})
              </TextV2>
            </TextV2>
          </StyledCheckboxV2>
        ))}
      </Flex>
    </FilterFacet>
  );
};
